import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatPaginator } from '@angular/material/paginator'
import { FormSearchComponent } from '../../../../shared/components/form-search/form-search.component'
import { PaginationComponent } from '../../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../../shared/components/table-list/table-list.component'
import { LegalEntityClientService } from '../../../../core/services/customer/legal-entity-client/legal-entity-client.service'
import { AuthService } from '../../../../core/services/auth/auth.service'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../../core/models/contact-type.model'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { TableListSelectComponent } from '../../../../shared/components/table-list-select/table-list-select.component'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SupplierService } from '../../../../core/services/person/supplier/supplier.service'
import { FormClientSearchComponent } from '../../../../shared/components/form-client-search/form-search.component'
import { SearchSupplierLegalModel } from '../../../../core/models/supplier.model'
import { SupplierCreateComponent } from '../supplier-create/supplier-create.component'
import { responseDefaultForm } from '../../../../shared/utils/utils'

@Component({
  selector: 'modal-supplier',
  imports: [
    FormSearchComponent,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    TableListSelectComponent,
    MatButton,
    MatProgressSpinner,
    FormClientSearchComponent,
  ],
  templateUrl: './modal-supplier.component.html',
  styleUrl: './modal-supplier.component.scss',
  standalone: true,
  providers: [SupplierService],
})
export class ModalSupplierComponent implements OnInit {
  constructor(
    private itemService: SupplierService,
    private dialogRef: MatDialogRef<ModalSupplierComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.multiSelect = data.multiSelect ?? false
    if (this.multiSelect) {
      this.listSelected = data.item
    } else {
      this.selected = data.item
    }
    if (data.create) {
      this.createBtn = true
    }
  }

  multiSelect: boolean = false

  createBtn: boolean = false

  @Output() responseSingle = new EventEmitter()

  @Output() responseMulti = new EventEmitter()

  listSelected: any[] = []
  selected: any = { id: -1, description: '' }

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false
  searchForm: any = { search: false, model: {} }
  inputSearch: string = ''
  columns: any[] = [
    {
      keyColumn: 'action',
      key: { select: true },
      description: '',
    },
    {
      keyColumn: 'name',
      key: 'nomeFantasia',
      description: 'Nome Fantasía',
    },
    {
      keyColumn: 'cnpj',
      key: 'cnpj',
      description: 'CNPJ',
    },
  ]

  listSearch: any = [
    {
      id: 'nomeFantasia',
      description: 'Nome Fantasia',
      type: 'string',
      visible: true,
    },
    // { id: 'cpf', description: 'CPF', type: 'string', visible: true },
    {
      id: 'razaoSocial',
      description: 'Razão Social',
      type: 'string',
      visible: true,
    },
    { id: 'cnpj', description: 'Cnpj', type: 'string', visible: true },
    {
      id: 'cidade',
      description: 'Cidade',
      type: 'string',
      visible: true,
    },
    {
      id: 'estado',
      description: 'Estado',
      type: 'string',
      visible: true,
    },
    {
      id: 'inscricaoEstadual',
      description: 'Insc. Estadual',
      type: 'string',
      visible: false,
    },
    {
      id: 'inscricaoMunicipal',
      description: 'Insc. Munucipal',
      type: 'string',
      visible: false,
    },
  ]
  screen: string = 'status operação'

  ngOnInit() {
    // this.getListItems()
    this.searchListItems()
  }

  close() {
    this.dialogRef.close()
  }

  createModal(event: any) {
    // event.type = campo selecionado (ex: 'nomeFantasia')
    // event.search = valor digitado
    let body: any = {
      nomeFantasia: '',
      razaoSocial: '',
      cnpj: '',
      inscricaoEstadual: '',
      inscricaoMunicipal: '',
    }

    // if(event.data.type == 'cnpj') {
    //   body = {
    //   nomeFantasia: '',
    //   razaoSocial: '',
    //   cnpj: event.data.search,
    //   inscricaoEstadual: '',
    //   inscricaoMunicipal: ''
    // }
    // }

    if (event.data.type && event.data.search) {
      body[event.data.type] = event.data.search
    }

    return body
  }

  createModelSearch(element: any) {
    let model: any = {
      inscMunicipal: '',
      inscEstadual: '',
      ativo: 'S',
    }

    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModelSearch(event.data),
      }
    } else {
      this.searchForm = {
        search: false,
        model: {},
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')

    // let search = event
    // this.page = 1
    // if (search) {
    //   this.searchForm.descricao = search
    //   this.searchListItems()
    // } else {
    //   this.getListItems()
    // }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  uploadList(type: string = '') {
    // if (type == 'new') {
    //   this.searchForm = new SearchContactTypeModel()
    // }
    // if (this.searchForm.descricao) {
    this.searchListItems()
    // } else {
    //   this.getListItems()
    // }
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.itemService.listPagedSupplierLegal(this.page, this.rows).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
      },
      error: (err: PagedContactTypeResponse) => {},
      complete: () => {
        this.loading = false
      },
    })
  }

  searchListItemsBkp() {
    this.loading = true
    this.itemService
      .searchPagedSupplier(this.page, this.rows, this.searchForm)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  searchListItems() {
    this.loading = true

    let model = {
      inscMunicipal: '',
      inscEstadual: '',
      ativo: 'S',
      nomeFantasia: '',
      razaoSocial: '',
      cnpj: '',
      inscricaoEstadual: '',
      cidade: '',
      estado: '',
      inscricaoMunicipal: '',
    }

    if (this.searchForm.search) {
      model = this.searchForm.model
    }

    this.itemService
      .searchPagedSupplierLegal(this.page, this.rows, model)
      // .searchPagedSupplierLegal(this.page, this.rows, this.searchForm)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {
          console.log('Erro: ', err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  selectItem(event: any) {
    if (this.multiSelect) {
      let index = this.listSelected.findIndex((ele) => ele.id == event.id)
      if (index > -1) {
        this.listSelected.splice(index, 1)
      } else {
        this.listSelected.push(event)
      }
    } else {
      if (this.selected.id == event.id) {
        this.selected = { id: -1, description: '' }
      } else {
        this.selected = event
      }
    }
  }

  checkForm() {
    if (this.selected.id >= 0 || this.listSelected.length > 0) {
      return true
    } else {
      return false
    }
  }

  removeSelection() {
    if (this.multiSelect) {
      this.responseMulti.emit({ remove: true })
    } else {
      this.responseSingle.emit({ remove: true })
    }
    this.close()
  }

  confirmSelection() {
    if (this.multiSelect) {
      this.responseMulti.emit({ remove: false, selection: this.listSelected })
    } else {
      this.responseSingle.emit({ remove: false, selection: this.selected })
    }
    this.close()
  }

  editItem(event: any) {
    console.log('event', event)
  }

  deleteItem(event: any) {
    console.log('event', event)
  }

  newSupplier() {
    const dialogRef = this.dialog.open(SupplierCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { modal: true },
    })
    dialogRef.componentInstance.responseModal.subscribe((response) => {
      console.log('response: ', response)
      this.uploadList()
    })
  }
}
